import type { EventView } from "~/business-areas/event/composables/event-view.hook";

export function useEventPageMetadata(event: Ref<EventView>) {
  const {
    public: {
      apps: { websiteBaseUrl },
    },
  } = useRuntimeConfig();

  const title = computed(
    () => `Événement exclusif - ${event.value.course.title}`,
  );

  const ogImage = computed(
    () =>
      event.value.course.og_image_url ??
      `${websiteBaseUrl}/images/brand/og-image.jpg`,
  );

  useSeoMeta({
    title,
    description: () => event.value.course.description,
    ogImage,
    robots: () => (event.value.course.indexed ? undefined : "noindex"),
  });

  useSchemaOrg([
    computed(() => {
      return {
        "@type": "Event",
        name: event.value.course.title,
        description: event.value.course.description,
        startDate: event.value.start_date,
        endDate: event.value.end_date,
        eventStatus: "EventScheduled",
        eventAttendanceMode: event.value.is_online
          ? "OnlineEventAttendanceMode"
          : "OfflineEventAttendanceMode",
        image: ogImage.value,
        organizer: {
          "@id": `${websiteBaseUrl}/#identity`,
        },
        performer: event.value.teacher
          ? definePerson({
              name: event.value.teacher.full_name!,
              image: event.value.teacher.avatar_url,
              url: `${websiteBaseUrl}/trainers/${event.value.teacher.slug}`,
            })
          : undefined,
        location: event.value.place
          ? {
              "@type": "Place",
              address: {
                "@type": "PostalAddress",
                addressLocality: event.value.place.address.city,
                postalCode: event.value.place.address.zip_code,
                streetAddress: `${event.value.place.address.street_number} ${event.value.place.address.street}`,
              },
              name: event.value.place.name,
            }
          : undefined,
      };
    }),
  ]);
}
